module.exports = __webpack_public_path__ + "img/bg_bansko-ski-map.c7235d3b.jpg";